export const GET_ME_START = 'GET_ME_START';
export const GET_ME_SUCCESS = 'GET_ME_SUCCESS';
export const GET_ME_FAIL = 'GET_ME_FAIL';
export const GET_ME_RESET = 'GET_ME_RESET';
